import React from "react";
import Page from "../../common/page/Page";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized";
import SponsoredInviteBlock from "./SponsoredInviteBlock";

export default function SponsoredInvitePage() {

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="SponsoredInvitePage">
          <Page.Content className="spaced-children">
            <SponsoredInviteBlock />
          </Page.Content>
        </Page>
      )}
    />
  );
}
